// src/utils/whatsappAccess.ts
// Acceso a las funciones de WhatsApp del negocio bajo el modelo "plan único + WhatsApp
// bajo solicitud" (2026-06-25). El envío de WhatsApp requiere un proxy dedicado que se
// provisiona a mano; por eso no basta el plan: hace falta `whatsappEnabled` en el negocio.
//
//   'free'    -> no es PRO: debe mejorar a PRO.
//   'request' -> es PRO pero aún no solicita activación: mostrar botón "Solicitar".
//   'pending' -> ya solicitó, en proceso de provisión.
//   'enabled' -> activado (proxy listo): funciona normal.
import type { User } from '../types/user';
import { isPro as checkIsPro } from './planPermissions';

export type WhatsappAccessState = 'free' | 'request' | 'pending' | 'enabled';

export function getWhatsappAccessState(user: User | null | undefined): WhatsappAccessState {
  // El admin (Carlos) siempre tiene acceso.
  if (user?.role === 'admin') return 'enabled';
  if (!checkIsPro(user?.subscription)) return 'free';
  if (user?.whatsappEnabled) return 'enabled';
  if (user?.whatsappRequested) return 'pending';
  return 'request';
}

/** ¿Puede USAR/enviar WhatsApp ahora mismo? (proxy provisionado) */
export function canUseWhatsapp(user: User | null | undefined): boolean {
  return getWhatsappAccessState(user) === 'enabled';
}
